const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'prime_pb_static_content',
    viewClass: require('./view'),
});
